import Button from '@rio-cloud/rio-uikit/Button';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';

import { useLocale } from '../../../configuration/lang/useLocale';
import useIsSupportAdministrationRoute from '../../../hooks/useIsSupportAdministrationRoute';
import { useOnboarding } from '../../../hooks/useOnboarding';
import { serviceInfoDialogClosed } from '../serviceInfoSlice';

export const IntroductionPage = () => {
    const dispatch = useDispatch();

    const { run } = useOnboarding();

    const isSupportAdminRoute = useIsSupportAdministrationRoute();

    const onShowOnboardingTour = () => {
        dispatch(serviceInfoDialogClosed());
        run();
    };

    const locale = useLocale();

    // use locale for link. Note that we have to use the long-locale last part except for en-GB, where we use the first part en
    const linkLocale = locale === undefined || locale === 'en-GB' ? 'en' : locale.split('-')[1].toLowerCase();
    const link = `https://rio.cloud/${linkLocale}/documents/manuals/service/rio4rental/at-a-glance`;

    return (
        <div data-testid='IntroductionPage' className='display-flex flex-column' style={{ minHeight: '800px' }}>
            <iframe className='flex-1-1 unstyled' title='Introduction' src={link} />
            {!isSupportAdminRoute && (
                <div className='display-flex column-gap-25 column-gap-50-md row-gap-25 justify-content-center flex-wrap align-items-end bg-lightest padding-25 margin-25 rounded-large'>
                    <div className=''>
                        <div className='text-size-h4 text-medium'>
                            <FormattedMessage id='intl-msg:rental-web.serviceinfo.welcome.onboarding.title' />
                        </div>
                        <div className=''>
                            <FormattedMessage id='intl-msg:rental-web.serviceinfo.welcome.onboarding.description' />
                        </div>
                    </div>
                    <Button bsStyle='primary' onClick={onShowOnboardingTour}>
                        <FormattedMessage id='intl-msg:rental-web.serviceinfo.welcome.onboarding.button' />
                    </Button>
                </div>
            )}
        </div>
    );
};
